// extracted by mini-css-extract-plugin
module.exports = {"page-title":"page-title--IvmNg","link":"link--2R9sC","active":"active--1AZ2K"};